<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-hdp-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-hdp-' + id"
    :aria-controls="'collapse-hdp-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_HDP", 1) }}
  .collapse.show(
    :aria-labelledby="'heading-hdp-' + id"
    :id="'collapse-hdp-' + id"
  )
    .card-body.p-0
      .market-card-content
        //- small.text-dark 123 {{ details['kns'] > 4 }}
        .normal(v-if="mode == 0 || mode == 1")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area.has-swiper-pagination
            .normal-odd-area-oddtype
              p.mb-0 {{ $t("m.ODD_Home") }}
              p.mb-0 {{ $t("m.ODD_Away") }}
            swiper(ref="sw" :options="{slidesPerView: details['kns'] > 4 ? 4 : details['kns'], spaceBetween: 0, pagination: {el: '.swiper-pagination',clickable: true}}" @slideChange="handleSlideChange")
              template(v-for="(dn, i) in details['kns']")
                swiper-slide
                  .normal-odd-area-group
                    template(v-if="details['hdp'] && details['hdp'][i] && details['hdp'][i][9] != 0 && details['hdp'][i][10] != 0 && details['hdp'][i][9] != '' && details['hdp'][i][10] != ''")
                      OddsItem(:odds="details['hdp'][i]" :idx="details['hdp'][i][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" :count="i" :details="details" homeAway="1")
                    template(v-else)
                      OddsDisabled
                    template(v-if="details['hdp'] && details['hdp'][i] && details['hdp'][i][9] != 0 && details['hdp'][i][10] != 0 && details['hdp'][i][9] != '' && details['hdp'][i][10] != ''")
                      OddsItem(:odds="details['hdp'][i]" :idx="details['hdp'][i][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" :count="i" :details="details" homeAway="2")
                    template(v-else)
                      OddsDisabled
              .swiper-pagination(v-if="details['kns'] > 4" slot="pagination")
        .normal(v-if="$helpers.objSize(details['hdph']) > 0 && (mode == 0 || mode == 2)")
          .normal-title {{ $t("ui.half_time") }}
          .normal-odd-area.has-swiper-pagination
            .normal-odd-area-oddtype
              p.mb-0 {{ $t("m.ODD_Home") }}
              p.mb-0 {{ $t("m.ODD_Away") }}
            swiper(ref="sw" :options="{slidesPerView: details['kns'] > 4 ? 4 : details['kns'], spaceBetween: 0, pagination: {el: '.swiper-pagination',clickable: true}}" @slideChange="handleSlideChange")
              template(v-for="(dn, i) in details['kns']")
                swiper-slide
                  .normal-odd-area-group
                    template(v-if="details['hdph'] && details['hdph'][i] && details['hdph'][i][9] != 0 && details['hdph'][i][10] != 0 && details['hdph'][i][9] != '' && details['hdph'][i][10] != ''")
                      OddsItem(:odds="details['hdph'][i]" :idx="details['hdph'][i][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdph" :count="i" :details="details" homeAway="1")
                    template(v-else)
                      OddsDisabled
                    template(v-if="details['hdph'] && details['hdph'][i] && details['hdph'][i][9] != 0 && details['hdph'][i][10] != 0 && details['hdph'][i][9] != '' && details['hdph'][i][10] != ''")
                      OddsItem(:odds="details['hdph'][i]" :idx="details['hdph'][i][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdph" :count="i" :details="details" homeAway="2")
                    template(v-else)
                      OddsDisabled
              .swiper-pagination(v-if="details['kns'] > 4" slot="pagination")
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        observer: true,
        observeParents: true
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    }
  },
  mounted() {
    this.activeIndex = this.swiper.activeIndex;
  },
  methods: {
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
    }
  }
}
</script>